import { UseMutationOptions, useMutation } from 'react-query';

import { SetPrimaryTeamMember } from '@pimm/services/lib/sms-workforce/services';
import type { TeamMember } from '../types';

// POST /api/Workforce/TeamMembers/SetPrimary — 409s unless the employee's
// Role is in SmsValidRoles and Status is Active. Same whole-record-replace
// response contract as every other write in this modal: the resolved value
// is the complete refreshed record for the NEW primary only — the previous
// primary's flip-off is patched locally (see updateCachedMember).
export type SetPrimaryManagerVars = { employeeId: string };

export const useSetPrimaryManager = (options?: UseMutationOptions<TeamMember, unknown, SetPrimaryManagerVars>) =>
  useMutation({
    mutationFn: async (vars: SetPrimaryManagerVars) => (await SetPrimaryTeamMember(vars)) as TeamMember,
    ...options,
  });
